'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/vux/~/axios/lib/cancel/isCancel.js
// module id = 222
// module chunks = 0